module.exports = __webpack_public_path__ + "img/CloudOff.0f566a27.png";